import { format } from 'date-fns'
import { DISPLAY_DATE_FORMAT, INTERNAL_DATE_FORMAT } from '../../../services/constants'
import LookupField from '../../../components/wells/lookup-field'
import { ExternalDocumentReferencesEdit } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { parseDate } from '../../aoraki/generic-search-common/src'
import { DateField, FormField, InputWidth, TextInput, Toggle } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'

interface WellFileProps {
  validationErrors: ValidationErrors<ExternalDocumentReferencesEdit>
  isLoading: boolean
  fields: Partial<ExternalDocumentReferencesEdit>
  setValue: SetValue<ExternalDocumentReferencesEdit>
  editForm: boolean
}

export function ExternalDocumentEditForm({ isLoading, fields, setValue, validationErrors, editForm }: WellFileProps) {
  return (
    <>
      <FormField
        isSkeleton={isLoading}
        label='Date added'
        htmlFor='dateAdded'
        validationMessages={validationErrors?.dateAdded}
        isRequired={!editForm}
      >
        <DateField
          dateFormat={DISPLAY_DATE_FORMAT}
          isSkeleton={isLoading}
          isDisabled={isLoading}
          fieldSize={InputWidth.large}
          selectedDate={parseDate(fields.dateAdded)}
          setSelectedDate={(date: Date) => setValue('dateAdded', date ? format(date, INTERNAL_DATE_FORMAT) : '')}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Document description'
        htmlFor='documentDescription'
        validationMessages={validationErrors?.documentDescription}
      >
        <TextInput
          isSkeleton={isLoading}
          id='documentDescription'
          value={`${fields?.documentDescription ?? ''}`}
          setValue={(value) => setValue('documentDescription', value)}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        validationMessages={validationErrors?.documentType}
        labelId='documentType'
        label='Document type'
        isRequired={!editForm}
      >
        <LookupField
          isSkeleton={isLoading}
          labelledBy='documentType'
          fieldId='documentType'
          value={fields?.documentType ?? ''}
          setValue={({ value }) => (fields.documentType = value)}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        validationMessages={validationErrors?.documentReference}
        labelId='documentReference'
        label='Document reference'
        isRequired={!editForm}
      >
        <TextInput
          isSkeleton={isLoading}
          id='documentReference'
          value={fields?.documentReference ?? ''}
          setValue={(value) => (fields.documentReference = value)}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        validationMessages={validationErrors?.documentLinkUrl}
        labelId='documentLinkUrl'
        label='Link URL'
        toolTipMessage={TOOLTIP.documentLinkUrl}
      >
        <TextInput
          isSkeleton={isLoading}
          id='documentLinkUrl'
          value={fields?.documentLinkUrl ?? ''}
          setValue={(value) => setValue('documentLinkUrl', value)}
          placeholder='e.g. https://your-docs.govt.nz/CM?t=record&q=number:123456'
        />
      </FormField>
      <FormField isSkeleton={isLoading} label='Show link to public?' htmlFor='documentLinkIsPublic'>
        <Toggle
          id='documentLinkIsPublic'
          name='documentLinkIsPublic'
          isSkeleton={isLoading}
          isDisabled={!fields?.documentLinkUrl}
          isChecked={fields?.documentLinkIsPublic ?? false}
          onChange={() => setValue('documentLinkIsPublic', !fields?.documentLinkIsPublic)}
        />
      </FormField>
    </>
  )
}
